/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BankBranchViewModel } from './BankBranchViewModel';
import {
    BankBranchViewModelFromJSON,
    BankBranchViewModelFromJSONTyped,
    BankBranchViewModelToJSON,
} from './BankBranchViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfListOfBankBranchViewModel
 */
export interface ResultOfListOfBankBranchViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfListOfBankBranchViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfBankBranchViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfBankBranchViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfBankBranchViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfBankBranchViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfListOfBankBranchViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfListOfBankBranchViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<BankBranchViewModel>}
     * @memberof ResultOfListOfBankBranchViewModel
     */
    data?: Array<BankBranchViewModel>;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfBankBranchViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfListOfBankBranchViewModel interface.
 */
export function instanceOfResultOfListOfBankBranchViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfListOfBankBranchViewModelFromJSON(json: any): ResultOfListOfBankBranchViewModel {
    return ResultOfListOfBankBranchViewModelFromJSONTyped(json, false);
}

export function ResultOfListOfBankBranchViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfListOfBankBranchViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ((json['Data'] as Array<any>).map(BankBranchViewModelFromJSON)),
        'count': json['Count'],
    };
}

export function ResultOfListOfBankBranchViewModelToJSON(value?: ResultOfListOfBankBranchViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': value.data === undefined ? undefined : ((value.data as Array<any>).map(BankBranchViewModelToJSON)),
        'Count': value.count,
    };
}

